<template>
  <div class="container-fluid py-4 px-4">
    <div class="row no-gutters">
      <div class="col-12 col-sm-6 col-md-8">
        <h4 class="font-weight-bold">{{ crewTon.vesselName }}</h4>
      </div>
      <div class="col-6 col-md-4 text-right">
        <button class="btn btn-sm btn-secondary small" @click="goBack">
          <font-awesome-icon icon="undo" />
          <span class="ml-1 ">Go Back</span>
        </button>
      </div>
    </div>

    <div class="row no-gutters py-2">
      <div class="col-md-12">
        <base-table :max-height="560" :loading="isLoading" :loader-colspan="9">
          <template slot="table-header">
            <tr class="align-middle">
              <th scope="col" class="p-1" style="width: 5% !important;">RANK</th>
              <th scope="col" class="p-1" style="width: 10% !important;">MANNING</th>
              <th scope="col" class="p-1" style="width: 25% !important;">NOTES FROM</th>
              <th scope="col" class="p-1" style="width: 10% !important;">TURN OVER NOTES</th>
              <th scope="col" class="p-1" style="width: 25% !important;">NOTES TO</th>
              <th scope="col" class="p-1" style="width: 12% !important;">USERNAME</th>
              <th scope="col" class="p-1" style="width: 12% !important;">PASSCODE</th>
              <th scope="col" class="p-1" style="width: 10% !important;">REMARKS</th>
              <th scope="col" class="p-1" style="width: 10% !important;" v-if="isSystemAdmin || isManning">ACTION</th>
            </tr>
          </template>
          <template slot="table-body" v-if="crewTon.data">
            <tr v-if="crewTon.data.length == 0">
              <td colspan="12">No record found.</td>
            </tr>

            <tr v-else v-for="(ton,rankIndex) in crewTon.data" :key="rankIndex">
              <td>
                {{ ton.rankName }}
              </td>
              <td>
                {{ton.manningAlias}}
              </td>
              <td class="text-left pl-lg-5 align-middle">
                <span v-if="ton.crewTonId">
                {{ ton.assignedBy ? ton.assignedBy.toUpperCase() : 'OTHER CREW' }}
                </span>
                </td>
              <td>
                <!-- <img v-if="ton.crewTonId"
                     :id="`img-excel-icon`+rankIndex"
                     class="img-thumbnail img-icon"
                     :class="{
                          'bg-secondary':!ton.hasFile && ton.crewTonId,
                          'unclickable'  : isFileDownload,
                      }"
                     :src="excelIcon"
                     alt="File Icon"
                     @click="downloadFileExcel(ton)">-->
                <button v-if="ton.crewTonId" class="btn-xs btn" @click="downloadFileExcel(ton)"
                        :id="`img-icon`+rankIndex"
                        :class="{
                          'bg-secondary' : !ton.hasFile && ton.crewTonId,
                          'bg-success' : ton.hasFile,
                          'unclickable' : isFileDownload,
                        }">
                  <font-awesome-icon icon="fa-paperclip" class="img-icon" :class="{'text-white' : !ton.hasFile && ton.crewTonId,'text-white' : ton.hasFile}"/>
                </button>
              </td>
              <td class="text-left pl-lg-5 align-middle">
                <span v-if="ton.crewTonId">
                    {{ ton.assignedTo ? ton.assignedTo.toUpperCase() : 'OTHER CREW' }}
                </span>
              </td>
              <td class="text-center align-middle" @click="copyOnClipBoard">
                <input
                    type="text"
                    class="form-control-plaintext text-center"
                    v-on:focus="$event.target.select()"
                    :value="ton.username"
                    readonly>
              </td>
              <td @click="copyOnClipBoard" class="text-center align-middle">
                <input v-on:focus="$event.target.select()" type="text" class="form-control-plaintext text-center" readonly :value="ton.passcode" />
              </td>
              <td>
                <button v-if="ton.remarks" class="btn btn-sm" @click="viewRemarks(ton)">
                  <font-awesome-icon icon="message" />
                  <sup class="pl-2 badge-pill badge-info">{{ ton.remarks.length }}</sup>
                </button>
              </td>
              <td v-if="isSystemAdmin || isManning" class="text-center">
                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle"
                          type="button"
                          id="actionMenu1"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false">
                    Menu
                  </button>
                  <div class="dropdown-menu" aria-labelledby="actionMenu1">
                    <div v-if="ton.crewTonId">
                      <base-modal-button
                          @thisButtonEvent="newRecord(ton)"
                          :target-modal-id="newCrewTonRecordModal"
                          :other-class="`dropdown-item px-0`">
                        <span class="dropdown-item-text text-primary">
                          <font-awesome-icon icon="file-alt" />
                          New TON Record
                        </span>
                      </base-modal-button>

                      <base-modal-button
                          @thisButtonEvent="editTon(ton)"
                          :target-modal-id="editTonRecordModal"
                          class="dropdown-item px-0">
                        <span class="dropdown-item-text text-info">
                            <font-awesome-icon icon="edit" />
                        Edit Details
                        </span>
                      </base-modal-button>
                      <base-modal-button v-if="ton.hasFile"
                                         @thisButtonEvent="replaceFile(ton)"
                                         :other-class="`dropdown-item px-0`"
                                         :target-modal-id="replaceFileModal">
                        <span class="dropdown-item-text text-warning">
                          <font-awesome-icon icon="recycle" />
                          Replace File
                        </span>
                      </base-modal-button>

                      <base-modal-button v-if="!ton.hasFile"
                                         :other-class="`dropdown-item px-0`"
                                         :target-modal-id="uploadFileModal"
                                         @thisButtonEvent="uploadFile(ton)">
                        <span class="dropdown-item-text text-secondary">
                          <font-awesome-icon icon="upload" />
                          Upload File
                        </span>
                      </base-modal-button>
                    </div>

                    <base-modal-button
                        v-if="!ton.crewTonId"
                        @thisButtonEvent="newRecord(ton)"
                        :target-modal-id="newCrewTonModal"
                        :other-class="`dropdown-item px-0`">
                     <span class="dropdown-item-text text-success">
                        <font-awesome-icon icon="plus" />
                        New Record
                      </span>
                    </base-modal-button>

                    <base-button v-if="ton.crewTonId"
                                 :other-class="'dropdown-item px-0'"
                                 @thisButtonEvent="deleteTon(ton.crewTonId)">
                      <span class="dropdown-item-text text-danger">
                        <font-awesome-icon icon="trash" />
                        Delete
                      </span>
                    </base-button>

                    <base-modal-button :other-class="'dropdown-item px-0'" :target-modal-id="fileHistoryModal"
                                       @thisButtonEvent="viewFileHistory(ton.fileHistories)">
                       <span class="dropdown-item-text text-success">
                        <font-awesome-icon icon="file-lines" />
                            File history
                       </span>
                    </base-modal-button>

                    <base-button
                        :other-class="`dropdown-item px-0 text-muted`"
                        @thisButtonEvent="cancelTon">
                      <span class="dropdown-item-text">
                         <font-awesome-icon icon="ban" />
                        Cancel
                      </span>
                    </base-button>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </base-table>
      </div>
    </div>

    <!-- fresh record   -->
    <base-modal :modal-title="`New turnover notes record`" :modalId="newCrewTonModal"
                :modal-size="`xxl`"
                :xl-height="true"
                @closingEvent="cancelNewTon">
      <template slot="modal-body">
        <div class="row mt-2 px-lg-4">
          <div class="col-sm-5">
            <form>
              <div class="form-group row mt-lg-2">
                <label for="assigned-by" class="col-sm-3 col-form-label font-weight-bold">Notes From</label>
                <div class="col-form-label">:</div>
                <div class="col-sm-8">
                  <input type="text"
                         v-if="!notesFromAnyms"
                         class="form-control form-control"
                         id="assigned-by"
                         :class="{
                            'is-valid': formNewCrewTon.assignedBy,
                            'is-invalid': !formNewCrewTon.assignedBy,
                          }"
                         v-model="thisAssignedBy"
                         v-focus
                         readonly
                         placeholder="notes from">
                  <div :class="{
                        'valid-feedback' : formNewCrewTon.assignedBy,
                        'invalid-feedback' : !formNewCrewTon.assignedBy,
                      }">
                  </div>

                  <div class="custom-control custom-checkbox" v-if="!notesToAnyms">
                    <input type="checkbox" name="UpNotesFrom" id="new-notes-frm-checkbox"
                           class="ml-2 form-check-inline custom-control-input"
                           v-model="notesFromAnyms" @click="notesFromAnymsFn('new-notes-frm-checkbox')">
                    <label class="custom-control-label small text-danger" for="up-notes-frm-checkbox">Check the box if crew not in the list</label>
                  </div>

                </div>

                <div class="row"  v-if="!notesFromAnyms">
                  <div class="col">
                    <button
                        type="button"
                        :btn-id="`btn-new-assign-crew`" v-if="!formNewCrewTon.assignedBy"
                        class="btn btn-sm"
                        :class="{
                          'btn-primary' : assigned == 1,
                          'btn-secondary' : assigned != 1,
                        }"
                        @click.prevent="assignCrew(1)">
                      <font-awesome-icon icon="plus" />
                    </button>
                    <base-button v-if="formNewCrewTon.assignedBy"
                                 :btn-size="`sm`"
                                 :is-btn-danger="true"
                                 @thisButtonEvent="remAssignedBy(1)">
                      <font-awesome-icon icon="times" />
                    </base-button>
                    </div>
                  </div>
              </div>

              <div class="form-group row mt-lg-2">
                <label for="assigned-to" class="col-sm-3 col-form-label font-weight-bold">Notes To</label>
                <div class="col-form-label">:</div>
                <div class="col-sm-8">
                  <input type="text"
                         v-if="!notesToAnyms"
                         class="form-control form-control"
                         id="assigned-to"
                         :class="{
                            'is-valid': formNewCrewTon.assignedTo,
                            'is-invalid': !formNewCrewTon.assignedTo,
                          }"
                         readonly
                         v-model="thisAssignedTo"
                         placeholder="notes to">

                    <div :class="{
                      'valid-feedback' : formNewCrewTon.assignedTo,
                      'invalid-feedback' : !formNewCrewTon.assignedTo,
                      'invalid-feedback' : formNewCrewTon.assignedTo && formNewCrewTon.assignedTo == formNewCrewTon.assignedBy,
                    }">
                  </div>
                  <div class="custom-control custom-checkbox" v-if="!notesFromAnyms">
                    <input type="checkbox" name="UpNotesFrom"
                           id="new-notes-to-checkbox"
                           class="ml-2 form-check-inline custom-control-input"
                           v-model="notesToAnyms"
                           @click="notesToAnymsFn('new-notes-to-checkbox')">
                    <label class="custom-control-label small text-danger" for="up-notes-to-checkbox">Check the box if crew not in the list</label>
                  </div>
                </div>

                <div class="row"  v-if="!notesToAnyms">
                  <div class="col">
                    <button type="button"
                            v-if="!formNewCrewTon.assignedTo"
                            class="btn btn-sm mt-lg-1"
                            :class="{
                          'btn-primary' : assigned == 2,
                          'btn-secondary' : assigned != 2,
                        }"
                            @click.prevent="assignCrew(2)">
                      <font-awesome-icon icon="plus" />
                    </button>
                    <base-button v-if="formNewCrewTon.assignedTo" :btn-size="`sm`" :is-btn-danger="true"
                                 @thisButtonEvent="remAssignedBy(2)">
                      <font-awesome-icon icon="times" />
                    </base-button>
                  </div>
                </div>
              </div>

              <div class="form-group row mt-lg-2">
                <label for="attach-new-ton-file" class="col-sm-3 col-form-label font-weight-bold">Attched file</label>
                <div class="col-form-label">:</div>
                <div class="col-sm-8">
                  <input type="file"
                         @change="handleFileNewCrewTon"
                         class="form-control-file"
                         id="attach-new-ton-file">
                  <small class="form-text text-muted mt-lg-2">* For multiple files; please compile it all using <b>.zip</b></small>
                  <small class="form-text text-muted">* <b>Only 1</b> file attachment per turn over notes</small>
                  <small class="form-text text-muted">* Valid file attachment are <b>word,excel,pdf,zip</b></small>
                </div>
              </div>

              <div class="card mt-lg-2">
                <div class="card-header">
                  <div class="card-text col-form-label font-weight-bold">Remarks</div>
                </div>

                <div class="card-body p-0">
                  <div class="form-group">

                  <textarea class="form-control form-control-sm border-0 py-2"
                            rows="6"
                            style="resize : none !important;"
                            v-model="formNewCrewTon.remarks"
                            placeholder="Remarks here . . ">
                  </textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-sm-7 border-left">
            <h5>{{ thisAssigned }}</h5>
            <div class="row">
              <div class="col-7">
                <base-pagination :page-object="objCrewKeysPagination" @settingPage="setPage"></base-pagination>
              </div>
              <div class="col-5" v-if="assigned == 2">
                  <div class="form-group row">
                    <label for="new-select-rank" class="col-sm-3 col-form-label">Rank</label>
                    <div class="col-form-label">:</div>
                    <div class="col-sm-5">
                      <select id="new-select-rank" class="form-control form-control-sm" v-model="formTonPayload.rankId" @change="searchCrewKeys">
                        <option :value="rank.id" v-for="(rank,index) in objRankKeys" :key="index">
                          {{rank.alias2}}
                        </option>
                      </select>
                    </div>
                  </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-table :loading="isSearchingCrew" :max-height="380" :loader-colspan="4">
                  <template slot="table-header">
                    <tr>
                      <th style="width: 7%!important;">
                        <button class="btn btn-sm" title="Refresh data here.">
                          <font-awesome-icon icon="undo" />
                        </button>
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sLastName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by last name . . . " />
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sFirstName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by first name . . . " />
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sMiddleName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by middle name . . . " />
                      </th>
                    </tr>
                    <tr>
                      <th>Rank</th>
                      <th>Last name</th>
                      <th>First Name</th>
                      <th>Middle Name</th>
                    </tr>
                  </template>

                  <template slot="table-body">
                    <tr v-if="objCrewKeys.length == 0">
                      <td colspan="4">No record found</td>
                    </tr>
                    <tr v-else v-for="(crew,index) in objCrewKeys"
                        :key="crew.id"
                        @click.prevent="setCrew({crew})"
                        :class="{
                      'is-selected' : selectedActive == crew.id
                    }">
                      <td class="text-center align-middle p-1">{{ crew.rank }}</td>
                      <td class="text-left pl-lg-5 align-middle p-1">{{ crew.lastName }}</td>
                      <td class="text-left pl-lg-5 align-middle p-1">{{ crew.firstName }}</td>
                      <td class="text-left pl-lg-5 align-middle p-1">{{ crew.middleName }}</td>
                    </tr>
                  </template>
                </base-table>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <base-button :is-btn-success="true" @thisButtonEvent="saveTon" :disable="isLoading">
          <font-awesome-icon icon="save" />
          Save
        </base-button>

        <base-button :is-btn-secondary="true" @thisButtonEvent="cancelNewTon" :disable="isLoading">
          Cancel
        </base-button>
      </template>
    </base-modal>

    <!-- edit record   -->
    <base-modal
        :xl-height="true"
        :modal-size="`xxl`"
        :modal-title="`Edit details`"
        :modal-id="editTonRecordModal"
        @closingEvent="cancelEditTon"
    >
      <template slot="modal-body">
        <div class="row mt-2 px-lg-4">
          <div class="col-6">
            <div class="form-group row">
              <label class="col-form-label col-sm-4"><small class="font-weight-bold">UPDATE NOTES FROM</small></label>
              <div class="col-form-label">:</div>
              <div class="col-sm-7">
                <input v-if="formTonUpdateData.assignedBy && !notesFromAnyms"
                       :value="thisAssignedBy"
                       class="form-control-plaintext"
                       readonly />

                <input v-else-if="notesFromAnyms || defaultAssignedBy == ''" class="form-control-plaintext" value="OTHER CREW" readonly/>

                <input v-else type="text" class="form-control-plaintext" :value="defaultAssignedBy" readonly />


                <div class="custom-control custom-checkbox" v-if="!notesFromAnyms">
                  <input type="checkbox" name="EditNoteFrom" id="edit-notes-frm-checkbox"
                         class="ml-2 form-check-inline custom-control-input"
                         v-model="notesFromAnyms"
                         @click="notesFromAnymsFn('edit-notes-frm-checkbox')">
                  <label class="custom-control-label small text-danger" for="up-notes-frm-checkbox">Check the box if crew not in the list</label>
                </div>
              </div>

              <div class="row"  v-if="!notesFromAnyms">
                <div class="col">
                  <button type="button" v-if="!formTonUpdateData.assignedBy" class="btn btn-sm"
                          :class="{
                          'btn-primary' : assigned == 1,
                          'btn-secondary' : assigned != 1,
                        }"
                          @click.prevent="assignCrew(1)">
                    <font-awesome-icon icon="edit" />
                  </button>
                  <base-button v-if="formTonUpdateData.assignedBy" :btn-size="`sm`" :is-btn-danger="true"
                               @thisButtonEvent="remAssignedBy(1)">
                    <font-awesome-icon icon="times" />
                  </base-button>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label class="col-form-label col-sm-4 font-weight-bold">
                <small class="font-weight-bold">UPDATE NOTES TO</small>
              </label>
              <div class="col-form-label">:</div>
              <div class="col-sm-7">
                <input v-if="formTonUpdateData.assignedTo && !notesToAnyms" :value="thisAssignedTo" class="form-control-plaintext"
                       readonly />

                <input v-else-if="notesToAnyms || defaultAssignedTo == ''" class="form-control-plaintext" value="OTHER CREW"/>

                <input v-else type="text" class="form-control-plaintext" :value="defaultAssignedTo" readonly />

                <div class="custom-control custom-checkbox" v-if="!notesToAnyms">
                  <input type="checkbox" name="EditNoteTo"
                         id="edit-notes-to-checkbox"
                         class="ml-2 form-check-inline custom-control-input"
                         v-model="notesToAnyms"
                         @click="notesToAnymsFn('edit-notes-to-checkbox')">
                  <label class="custom-control-label small text-danger" for="up-notes-to-checkbox">Check the box if crew not in the list</label>
                </div>
              </div>


              <div class="row"  v-if="!notesToAnyms">
                <div class="col">
                  <button
                      type="button"
                      v-if="!formTonUpdateData.assignedTo"
                      class="btn btn-sm"
                      :class="{
                          'btn-primary' : assigned == 2,
                          'btn-secondary' : assigned != 2,
                        }"
                      @click.prevent="assignCrew(2)">
                    <font-awesome-icon icon="edit" />
                  </button>
                  <base-button v-if="formTonUpdateData.assignedTo" :btn-size="`sm`" :is-btn-danger="true"
                               @thisButtonEvent="remAssignedBy(2)">
                    <font-awesome-icon icon="times" />
                  </base-button>
                </div>
              </div>
            </div>

            <div class="form-group row">
              <label for="update-attach-file" class="col-sm-4 font-weight-bold">Update Attachfile</label>
              <div class="col-form-label">:</div>
              <div class="col-sm-7">
                <input type="file" class="form-inline" id="update-attach-file" @change="handleFileUpdateCrewTOn">
                <small class="form-text text-muted mt-lg-2">* For multiple files; please compile it all using <b>.zip</b></small>
                <small class="form-text text-muted">* <b>Only 1</b> file attachment per turn over notes</small>
                <small class="form-text text-muted">* Valid file attachment are <b>word,excel,pdf,zip</b></small>
              </div>
            </div>

            <div class="card mt-lg-2">
              <div class="card-header">
                <div class="card-text col-form-label font-weight-bold">
                  Remarks
                </div>
              </div>

              <div class="card-body p-0">
                <div class="form-group">
                  <textarea class="form-control form-control-sm border-0 py-2"
                            rows="6"
                            style="resize : none !important;"
                            v-model="formTonUpdateData.remarks"
                            placeholder="Remarks here . . ">
                  </textarea>
                </div>
              </div>
            </div>

          </div>
          <div class="col-6 border-left">
            <h5>{{ thisAssigned }}</h5>
            <div class="row">
              <div class="col-8">
                <base-pagination :page-object="objCrewKeysPagination" @settingPage="setPage"></base-pagination>
              </div>
              <div class="col-4" v-if="assigned == 2">
                <div class="form-group row">
                  <label for="edit-select-rank" class="col-sm-3 col-form-label">Rank</label>
                  <div class="col-form-label">:</div>
                  <div class="col-sm-5">
                    <select id="edit-select-rank" class="form-control form-control-sm" v-model="formTonPayload.rankId" @change="searchCrewKeys">
                      <option :value="rank.id" v-for="(rank,index) in objRankKeys" :key="index">
                        {{rank.alias2}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-table :loading="isSearchingCrew" :max-height="380" :loader-colspan="4">
                  <template slot="table-header">
                    <tr>
                      <th style="width: 7%!important;">
                        <button class="btn btn-sm" title="Refresh data here.">
                          <font-awesome-icon icon="undo" />
                        </button>
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sLastName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by last name . . . " />
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sFirstName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by first name . . . " />
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sMiddleName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by middle name . . . " />
                      </th>
                    </tr>
                    <tr>
                      <th>Rank</th>
                      <th>Last name</th>
                      <th>First Name</th>
                      <th>Middle Name</th>
                    </tr>
                  </template>

                  <template slot="table-body">
                    <tr v-if="objCrewKeys.length == 0">
                      <td colspan="4">No record found</td>
                    </tr>
                    <tr v-else v-for="(crew,index) in objCrewKeys"
                        :key="crew.id"
                        @click.prevent="setCrew({crew})"
                        :class="{
                      'is-selected' : selectedActive == crew.id
                    }">
                      <td class="text-center align-middle p-1">{{ crew.rank }}</td>
                      <td class="text-left pl-lg-5 align-middle p-1">{{ crew.lastName }}</td>
                      <td class="text-left pl-lg-5 align-middle p-1">{{ crew.firstName }}</td>
                      <td class="text-left pl-lg-5 align-middle p-1">{{ crew.middleName }}</td>
                    </tr>
                  </template>
                </base-table>
              </div>
              </div>
          </div>
        </div>
      </template>
      <template slot="modal-footer">
        <base-button btn-size="md" @thisButtonEvent="saveEditTon" :is-btn-success="true">
          <font-awesome-icon icon="save" />
          Update
        </base-button>
        <base-button btn-size="md" @thisButtonEvent="cancelEditTon" :is-btn-danger="true">
          <font-awesome-icon icon="times" />
          Cancel
        </base-button>
      </template>
    </base-modal>

    <!-- has existing && create new record   -->
    <base-modal :modal-id="newCrewTonRecordModal"
                :modal-title="`Upload new turnover notes record`"
                :modal-size="`xxl`"
                @closingEvent="cancelNewTonRecord"
                :xl-height="true">
      <template slot="modal-body">
        <div class="row mt-2 px-lg-4">
          <div class="col-sm-6">
            <form>
              <div class="form-group row mt-lg-2">
                <label for="assigned-by" class="col-sm-3 col-form-label font-weight-bold">Notes From</label>
                <div class="col-form-label">:</div>
                <div class="col-sm-8 align-items-center">
                  <input type="text"
                          v-if="!notesFromAnyms"
                         class="form-control form-control"
                         id="upload-assigned-by"
                         :class="{
                            'is-valid': formNewCrewTon.assignedBy,
                            'is-invalid': !formNewCrewTon.assignedBy,
                          }"
                         v-focus
                         v-model="thisAssignedBy"
                         readonly
                         placeholder="notes from">
                  <div :class="{
                        'valid-feedback' : formNewCrewTon.assignedBy,
                        'invalid-feedback' : !formNewCrewTon.assignedBy,
                      }">
                  </div>

                  <div class="custom-control custom-checkbox" v-if="!notesToAnyms">
                    <input type="checkbox" name="UpNotesFrom" id="up-notes-frm-checkbox"
                           class="ml-2 form-check-inline custom-control-input"
                           v-model="notesFromAnyms" @click="notesFromAnymsFn('up-notes-frm-checkbox')">
                    <label class="custom-control-label small text-danger" for="up-notes-frm-checkbox">Check the box if crew not in the list</label>
                  </div>
                </div>

                <div class="row"  v-if="!notesFromAnyms">
                  <div class="col">
                    <button type="button"
                            v-if="!formNewCrewTon.assignedBy"
                            class="btn btn-sm mt-lg-1"
                            :class="{
                          'btn-primary' : assigned == 1,
                          'btn-secondary' : assigned != 1,
                        }"
                            @click.prevent="assignCrew(1)">
                      <font-awesome-icon icon="plus" />
                    </button>
                    <base-button v-if="formNewCrewTon.assignedBy" :btn-size="`sm`" :is-btn-danger="true"
                                 other-class="mt-lg-1"
                                 @thisButtonEvent="remAssignedBy(1)">
                      <font-awesome-icon icon="times" />
                    </base-button>
                  </div>
                </div>

              </div>

              <div class="form-group row mt-lg-2">
                <label for="assigned-to" class="col-sm-3 col-form-label font-weight-bold">Notes To</label>
                <div class="col-form-label">:</div>
                <div class="col-sm-8">
                  <input type="text"
                         v-if="!notesToAnyms"
                         class="form-control form-control"
                         id="upload-assigned-to"
                         :class="{
                            'is-valid': formNewCrewTon.assignedTo,
                            'is-invalid': !formNewCrewTon.assignedTo,
                          }"
                         readonly
                         v-model="thisAssignedTo"
                         placeholder="notes to">

                  <div :class="{
                      'valid-feedback' : formNewCrewTon.assignedTo,
                      'invalid-feedback' : !formNewCrewTon.assignedTo,
                      'invalid-feedback' : formNewCrewTon.assignedTo && formNewCrewTon.assignedTo == formNewCrewTon.assignedBy,
                    }">
                  </div>
                  <div class="custom-control custom-checkbox" v-if="!notesFromAnyms">
                    <input type="checkbox" name="UpNotesFrom"
                           id="up-notes-to-checkbox"
                           class="ml-2 form-check-inline custom-control-input"
                           v-model="notesToAnyms"
                           @click="notesToAnymsFn('up-notes-to-checkbox')">
                    <label class="custom-control-label small text-danger" for="up-notes-to-checkbox">Check the box if crew not in the list</label>
                  </div>
                </div>
                <div class="row" v-if="!notesToAnyms">
                  <div class="col">
                    <button type="button"
                            v-if="!formNewCrewTon.assignedTo"
                            class="btn btn-sm"
                            :class="{
                          'btn-primary' : assigned == 2,
                          'btn-secondary' : assigned != 2,
                        }"
                            @click.prevent="assignCrew(2)">
                      <font-awesome-icon icon="plus" />
                    </button>
                    <base-button v-if="formNewCrewTon.assignedTo" :btn-size="`sm`" :is-btn-danger="true"
                                 @thisButtonEvent="remAssignedBy(2)">
                      <font-awesome-icon icon="times" />
                    </base-button>
                  </div>
                </div>
              </div>

              <div class="form-group row mt-lg-2">
                <label for="attach-new-ton-file" class="col-sm-3 col-form-label font-weight-bold">Attched file</label>
                <div class="col-form-label">:</div>
                <div class="col-sm-8">
                  <input type="file"
                         @change="handleFileNewCrewTon"
                         class="form-control-file"
                         id="upload-attach-new-ton-file">
                  <small class="form-text text-muted mt-lg-2">* For multiple files; please compile it all using <b>.zip</b></small>
                  <small class="form-text text-muted">* <b>Only 1</b> file attachment per turn over notes</small>
                  <small class="form-text text-muted">* Valid file attachment are <b>word,excel,pdf,zip</b></small>
                </div>
              </div>

              <div class="card mt-lg-2">
                <div class="card-header">
                  <div class="card-text col-form-label font-weight-bold">
                    Remarks
                  </div>
                </div>

                <div class="card-body p-0">
                  <div class="form-group">
                  <textarea class="form-control form-control-sm border-0 py-2"
                            rows="6"
                            style="resize : none !important;"
                            v-model="formNewCrewTon.comment"
                            placeholder="Remarks here . . ">
                  </textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-sm-6 border-left">
            <h5>{{ thisAssigned }}</h5>
            <div class="row">
              <div class="col">
                <base-pagination :page-object="objCrewKeysPagination" @settingPage="setPage"></base-pagination>
              </div>

              <div class="col-5" v-if="assigned == 2">
                <div class="form-group row">
                  <label for="upload-select-rank" class="col-sm-3 col-form-label">Rank</label>
                  <div class="col-form-label">:</div>
                  <div class="col-sm-5">
                    <select id="upload-select-rank" class="form-control form-control-sm" v-model="formTonPayload.rankId" @change="searchCrewKeys">
                      <option :value="rank.id" v-for="(rank,index) in objRankKeys" :key="index">
                        {{rank.alias2}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-table :loading="isSearchingCrew" :max-height="380" :loader-colspan="4">
                  <template slot="table-header">
                    <tr>
                      <th style="width: 7%!important;">
                        <button class="btn btn-sm" title="Refresh data here.">
                          <font-awesome-icon icon="undo" />
                        </button>
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sLastName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by last name . . . " />
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sFirstName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by first name . . . " />
                      </th>
                      <th style="width: 30%!important;">
                        <input @keyup="callSearchDebounce" v-model="formTonPayload.sMiddleName"
                               class="form-control form-control-sm" type="search"
                               placeholder="Search by middle name . . . " />
                      </th>
                    </tr>
                    <tr>
                      <th>Rank</th>
                      <th>Last name</th>
                      <th>First Name</th>
                      <th>Middle Name</th>
                    </tr>
                  </template>

                  <template slot="table-body">
                    <tr v-if="objCrewKeys.length == 0">
                      <td colspan="4">No record found</td>
                    </tr>
                    <tr v-else v-for="(crew,index) in objCrewKeys"
                        :key="crew.id"
                        @click.prevent="setCrew({crew})"
                        :class="{
                      'is-selected' : selectedActive == crew.id
                    }">
                      <td class="text-center align-middle p-1">{{ crew.rank }}</td>
                      <td class="text-left pl-lg-2 align-middle p-1">{{ crew.lastName }}</td>
                      <td class="text-left pl-lg-2 align-middle p-1">{{ crew.firstName }}</td>
                      <td class="text-left pl-lg-2 align-middle p-1">{{ crew.middleName }}</td>
                    </tr>
                  </template>
                </base-table>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template slot="modal-footer">
        <base-button :is-btn-success="true" @thisButtonEvent="saveNewTonRecord" :disable="isLoading">
          <font-awesome-icon icon="save" />
          Save
        </base-button>

        <base-button :is-btn-secondary="true" @thisButtonEvent="cancelNewTonRecord" :disable="isLoading">
          Cancel
        </base-button>
      </template>
    </base-modal>

    <!-- replace  -->
    <base-modal :modal-id="replaceFileModal" :modal-title="`Replace file attach on this record`"
                @closingEvent="cancelReplaceFile">
      <template slot="modal-body">
        <div class="form-group">
          <label for="upload-attached-file"
                 class="col-form-label font-weight-bold">Replace Attached file</label>
          <input type="file" @change="handleReplaceFile" class="form-control-file" id="replace-attached-file">
        </div>
      </template>

      <template slot="modal-footer">
        <base-button :is-btn-success="true" @thisButtonEvent="saveReplaceFile" :disable="isFileUploading">
          <font-awesome-icon icon="save" />
          Save
        </base-button>
        <base-button :is-btn-danger="true" @thisButtonEvent="cancelReplaceFile" :disable="isFileUploading">
          <font-awesome-icon icon="times" />
          Cancel
        </base-button>
      </template>
    </base-modal>

    <!-- upload file    -->
    <base-modal :modal-id="uploadFileModal" :modal-title="`Upload turnover file`" @closingEvent="cancelUploadFile">
      <template slot="modal-body">
        <div class="form-group">
          <label for="upload-attached-file"
                 class="col-form-label font-weight-bold">Attached file</label>
          <input type="file" @change="handleUploadFile" class="form-control-file" id="upload-attached-file">
        </div>

        <div class="form-group">
          <label for="upload-remarks" class="col-form-label font-weight-bold">Remarks</label>
          <textarea class="form-control"
                    id="upload-remarks"
                    rows="3"
                    v-model="formTonUploadReplaceFile.remarks"
                    style="resize:none !important;"
                    placeholder="Remarks here.."></textarea>
        </div>
      </template>
      <template slot="modal-footer">
        <base-button :is-btn-success="true" @thisButtonEvent="saveUploadFile" :disable="isFileUploading">
          <font-awesome-icon icon="save" />
          Save
        </base-button>
        <base-button :is-btn-danger="true" @thisButtonEvent="cancelUploadFile">
          <font-awesome-icon icon="times" />
          Cancel
        </base-button>
      </template>
    </base-modal>

    <!-- history   -->
    <base-modal
        :modal-id="fileHistoryModal"
        :modal-title="`TON File history`"
        @closingEvent="cancelFileHistory">
      <template slot="modal-body">
        <base-table :max-height="400">
          <template slot="table-header">
            <tr>
              <th>#</th>
              <th>File</th>
              <th>Created At</th>
            </tr>
          </template>
          <template slot="table-body">
            <tr v-if="crewTonFileHistories.length == 0">
              <td colspan="3">No record found.</td>
            </tr>
            <tr v-else v-for="(history,index) in crewTonFileHistories" :key="history.crewTonFileHistoryId">
              <td>{{ index + 1 }}</td>
              <td>
                <!--  //todo  -->
<!--                <img v-if="history.crewTonFileHistoryId"
                     :id="`img-excel-icon`+index"
                     class="img-thumbnail img-icon"
                     :class="{
                          'unclickable'  : isFileDownload,
                      }"
                     :src="excelIcon"
                     alt="File Icon"
                     @click="downloadThisFileHistory(history)">-->
                <button class="btn-xs btn"
                        :class="{
                          'unclickable'  : isFileDownload,
                      }"
                      @click="downloadThisFileHistory(history)">
                  <font-awesome-icon icon="fa-paperclip"/>
                </button>
              </td>
              <td>{{ history.createdAt }}</td>
            </tr>
          </template>
        </base-table>
      </template>
    </base-modal>

    <!--  remarks  -->
    <base-modal
        :modal-id="remarksModal"
        :modal-size="`xl`"
        :modal-title="`Turnover notes remarks`"
        @closingEvent="cancelRemarks">
      <template slot="modal-body">
        <div class="row">
          <div class="col-5">
            <div class="card">
              <div class="card-body p-0">
                <div class="card-title font-weight-bold px-lg-2 py-2">
                  <span v-if="crewTonRemark.hasOwnProperty('remarksByName')">{{ crewTonRemark.remarksByName }}</span>
                  <span v-else class="font-weight-bold px-lg-1 py-2">{{authUser.name}}</span>
                </div>
                <textarea v-if="isNewRemarks" class="form-control form-control-sm border-0 py-2"
                          rows="5"
                          :disabled="!isEditable"
                          style="height: 400px !important; resize: none !important;"
                          v-model="newCrewTonRemark.remarks"
                          placeholder="Add comment here . . ">
                </textarea>
                <textarea v-else class="form-control form-control-sm border-0 py-2"
                          rows="4"
                          :disabled="!isEditable"
                          style="height: 400px !important; resize: none !important;"
                          v-model="crewTonRemark.remarks"
                          placeholder="Add comment here . . ">
                </textarea>
              </div>
              <div class="card-footer bg-white">
                <div class="row no-gutters justify-content-between align-items-center">
                  <div class="col-12 col-md-auto align-content-center">
                    <button class="btn"
                            :class="{
                                'plain-btn-active text-white' : isNewRemarks,
                                'plain-btn' : !isNewRemarks,
                            }"
                            @click="addRemarks">
                      <font-awesome-icon icon="plus" />
                      New
                    </button>

                    <base-button
                        v-if="crewTonRemark.hasOwnProperty('remarkId') && !isEditable && crewTonRemark.remarksTypeId == authPos.id"
                        :other-class="`plain-btn`" @thisButtonEvent="editRemarks">
                      <font-awesome-icon class="text-warning" icon="pencil" />
                      <span>Edit</span>
                    </base-button>

                    <base-button v-if="crewTonRemark.hasOwnProperty('remarkId') && crewTonRemark.remarksTypeId == authPos.id" :other-class="`plain-btn`"
                                 @thisButtonEvent="deleteRemarks()">
                      <font-awesome-icon class="text-danger" icon="trash" />
                      <span>Del</span>
                    </base-button>

                    <base-button v-if="isAddComment" :other-class="`plain-btn`"
                                 @thisButtonEvent="cancelTextAreaRemarks">
                      <font-awesome-icon icon="undo" />
                      Cancel
                    </base-button>
                  </div>

                  <div class="col-12 col-md-auto">
                    <button v-if="isNewRemarks || isEditable"
                                 class="btn btn-xs "
                            :class="{
                              'bg-secondary' : !isNewRemarks,
                              'bg-secondary' : !isEditable,
                              'bg-primary text-white' : isNewRemarks,
                              'bg-primary text-white' : isEditable,
                            }"
                                 @click="saveRemarks"
                                 :disabled="!isAddComment">
                      <font-awesome-icon icon="message" />
                      <span class="font-weight-bold pl-lg-1">
                        {{isViewingRemarks ? 'Update' : 'Save'}}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-7 border-left">
            <base-table>
              <template slot="table-header">
                <tr>
                  <th class="text-center align-middle font-weight-bold" style="width: 3% !important;">#</th>
                  <th class="text-center align-middle font-weight-bold" style="width: 50% !important;">Remarks</th>
                </tr>
              </template>
              <template slot="table-body">
                <tr v-if="crewTonRemarks.length == 0">
                  <td colspan="2">No records found.</td>
                </tr>
                <tr v-else @click="setRemark(remark)" v-for="(remark,index) in crewTonRemarks"
                    :class="{
                      'unclickable' : isNewRemarks,
                      // 'is-selected' : crewTonRemark.crewTonId === remark.crewTonId
                    }"
                    :key="remark.remarkId">
                  <td>{{ index + 1 }}</td>
                  <td class="text-left align-middle">
                    <div class="card mb-3 border-0">
                      <div class="card-header">
                        <div class="row">
                          <div class="col-5">
                            <label class="font-weight-bold col-form-label">{{ remark.remarksByName }}</label>
                          </div>

                          <div class="col-3">
                            <span class="pl-lg-2">( {{ remark.remarksTypeName }} )</span>
                          </div>

                          <div class="col-4">
                            <span>[ {{ remark.createdAt }} ]</span>
                          </div>
                        </div>
                      </div>
                      <div class="card-body text-dark">
                        <!--<h5 class="card-title">Primary card title</h5>-->
                        <p class="card-text">{{ remark.remarks }}</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </base-table>
          </div>
        </div>
      </template>
    </base-modal>

    <BaseLoadingPopUp loading-i-d="progressBarModal" loading-title="Download File"></BaseLoadingPopUp>

  </div>
</template>

<script>
import {AppMixins} from '../../../mixins/app.mixins';
import UploadFile from '@/views/mock-views/UploadFile';
import excelIcon from '@/assets/excel.png';
import ReplaceFile from '@/views/mock-views/ReplaceFile';
import AssignFileToCrew from '@/views/mock-views/AssignFileToCrew';
import {mapActions, mapGetters} from 'vuex';
import router from '../../../router';
import {AppService} from '../../../service/app.service';
import {PosMixins} from '../../../mixins/pos.mixins';
import BaseLoadingPopUp from "@/components/base/loading/BaseLoadingPopUp";
import __ from 'lodash';

export default {
  name: 'TonView',

  /** mixins **/
  mixins: [AppMixins,PosMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {
      excelIcon,
      newCrewTonModal: 'new-crewton-modal',
      replaceFileModal: 'replace-file-modal',
      uploadFileModal: 'upload-file-modal',
      newCrewTonRecordModal: 'new-crew-ton-record-modal',
      editTonRecordModal: 'edit-ton-record-modal',
      fileHistoryModal: 'file-history-modal',
      searchCrewModal: 'search-crew-modal',
      remarksModal: 'remarks-modal',

      assigned: 1, // default to,

      selectedAssignedBy: null,
      selectedAssignedTo: null,
      selectedActive: null,

      defaultAssignedBy: null,
      defaultAssignedTo: null,

      formTonUpdateData: {
        crewTonId: null,
        assignedBy: '',
        assignedTo: '',
        remarks: null,
        file: null,
      },

      isFileDownload: false,
      isFileUploading: false,

      isEditable: false,
      isNewRemarks: false,
      isAddComment: false,
      isViewingRemarks : false,

      formCrewTonId: null,


      formRankTmp : null,

      notesFromAnyms : false,
      notesToAnyms : false,
    };
  },
  components: {
    UploadFile,
    ReplaceFile,
    AssignFileToCrew,
    BaseLoadingPopUp
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'getVesselCrewTons',
          'setTonPayloadRank',
          'resetCrewTon',
          'resetFormNewCrewTon',
          'getCrewKeysPaginated',
          'resetObjCrewKeysPagination',
          'resetSearchObjCrew',
          'createCrewTon',
          'updateCrewTon',
          'deleteCrewTon',
          'downloadTonFile',
          'uploadCrewTonFile',
          'replaceCrewTonFile', //replaceCrewTonFile
          'resetFormTonUploadReplaceFile',

          //remarks
          'resetCrewTonRemarksState',
          'setCrewTonRemark',
          'setCrewTonRemarks',
          'createTonRemark',
          'resetCrewTonRemark',
          'getCrewTonRemarkOriginal',
          'deleteTonRemark',
          'updateTonRemark',

          //ton history methods
          'setTonFileHistory',
          'setTonFileHistories',
          'resetFileHistoryVuex',
          'downloadFileHistory',
        ],
    ),

    loadData() {
      if (!this.crewTon.hasOwnProperty('vesselName')) {
        console.log('This is something needs to be done.')
        this.formTonPayload.manningId = AppService.originalState('auth', 'authUser').hasOwnProperty('manningId')
            ? AppService.originalState('auth', 'authUser').manningId
            : null;

        //this.formTonPayload.vesselId = AppService.originalState('crewTon','vesselId')
        this.getVesselCrewTons(this.formTonPayload);
      }
    },

    async downloadFileExcel(__file) {
      if (!__file.hasFile) {
        this.warningFormAlert('No Turn over notes file uploaded');
      } else {
        const progressModal = $('#progressBarModal')
        let msgHtml = '<span>Do you want to download attach file</span>';
        if (await this.questionFormAlert(msgHtml, 'Download Vessel Turn over notes')) {
          progressModal.modal('show')
          const formData = {
            crewTonId: __file.crewTonId,
            fileName: `${__file.rankName}_Turn_over_notes`,
          };
          this.isFileDownload = true;
          this.downloadTonFile(formData).then((r) => {
            if (r) {
              progressModal.modal('hide')
              this.isFileDownload = false;
              this.successFormAlert('Download Turnover notes file successfully');
            }
          });
        }
      }
    },

    async newRecord(__objTon) {
      this.formNewCrewTon.renewFrom = __objTon.crewTonId;
      this.formTonPayload.rankId = __objTon.rankId;
      this.formRankTmp = __objTon.rankId;
      this.setTonPayloadRank(__objTon.rankId);
      this.$nextTick(() => {
        this.getCrewKeysPaginated(this.formTonPayload);
      });
    },

    /** saving fresh record **/
    async saveTon() {
      this.formNewCrewTon.manningId = this.formTonPayload.manningId;
      this.formNewCrewTon.rankId = this.formRankTmp;
      this.formNewCrewTon.vesselId = this.formTonPayload.vesselId;

      let msgHtml = '<span>Are you sure you want to save this record</span>';
      if (await this.questionFormAlert(msgHtml, 'New Record')) {
        const newCrewTon = new FormData();

        // console.log('assigned By', this.formNewCrewTon.assignedBy);
        // console.log('assigned To', this.formNewCrewTon.assignedTo);

        newCrewTon.append('assignedBy', this.formNewCrewTon.assignedBy ? this.formNewCrewTon.assignedBy : '');
        newCrewTon.append('assignedTo', this.formNewCrewTon.assignedTo ? this.formNewCrewTon.assignedTo : '');
        newCrewTon.append('rankId', this.formNewCrewTon.rankId);
        newCrewTon.append('vesselId', this.formNewCrewTon.vesselId);
        newCrewTon.append('manningId', this.formNewCrewTon.manningId);
        newCrewTon.append('remarks', this.formNewCrewTon.remarks);
        newCrewTon.append('isFromAnyms',this.notesFromAnyms ? 1 : 0)
        newCrewTon.append('isToAnyms',this.notesToAnyms ? 1 : 0)
        newCrewTon.append('file', this.formNewCrewTon.file ? this.formNewCrewTon.file : '');
        this.createCrewTon(newCrewTon).then((r) => {
          if (r) {
            this.successFormAlert('New crew turnover notes created successfully');
            this.$nextTick(() => {
              this.hideThisModal(this.newCrewTonModal);
              this.getVesselCrewTons(this.formTonPayload);
              this.resetFormNewCrewTon();
              this.assigned = 1;
            });
            this.reset();
          }
        });
      }
    },

    /** saving new set of record **/
    async saveNewTonRecord() {
      this.formNewCrewTon.manningId = this.formTonPayload.manningId;
      this.formNewCrewTon.rankId = this.formRankTmp;
      this.formNewCrewTon.vesselId = this.formTonPayload.vesselId;

      let msgHtml = '<span>Do you want to renew this TURNOVER NOTES record <br> record with this following details</span>';
      if (await this.questionFormAlert(msgHtml, 'Renew Turnover notes record details')) {
        // console.log('This is log for the renew');
        const newCrewTonRecord = new FormData();
        newCrewTonRecord.append('assignedBy', this.formNewCrewTon.assignedBy ? this.formNewCrewTon.assignedBy : '');
        newCrewTonRecord.append('assignedTo', this.formNewCrewTon.assignedTo ? this.formNewCrewTon.assignedTo : '');
        newCrewTonRecord.append('rankId', this.formNewCrewTon.rankId);
        newCrewTonRecord.append('vesselId', this.formNewCrewTon.vesselId);
        newCrewTonRecord.append('manningId', this.formNewCrewTon.manningId);
        newCrewTonRecord.append('remarks', this.formNewCrewTon.remarks);
        newCrewTonRecord.append('renewFrom', this.formNewCrewTon.renewFrom);
        newCrewTonRecord.append('isFromAnyms',this.notesFromAnyms ? 1 : 0)
        newCrewTonRecord.append('isToAnyms',this.notesToAnyms ? 1 : 0)
        newCrewTonRecord.append('file', this.formNewCrewTon.file ? this.formNewCrewTon.file : '');
        this.createCrewTon(newCrewTonRecord).then((r) => {
          if (r) {
            this.successFormAlert('New record of crew turnover notes created successfully');
            this.$nextTick(() => {
              this.hideThisModal(this.newCrewTonRecordModal);
              this.getVesselCrewTons(this.formTonPayload);
              this.resetFormNewCrewTon();
            });
            this.reset();
          }
        });
      }
    },

    reset() {
      $(`#upload-attach-new-ton-file`).val('');
      $(`#attach-new-ton-file`).val('');

      this.assigned = 1;
      this.formTonPayload.page = 1;
      this.formTonPayload.assignedType = 1;
      this.defaultAssignedBy = null;
      this.defaultAssignedTo = null;
      this.selectedAssignedBy = null;
      this.selectedAssignedTo = null;
      this.formTonPayload.sFirstName = null;
      this.formTonPayload.sMiddleName = null;
      this.formTonPayload.sLastName = null;
      this.selectedActive = null;

      this.formTonUpdateData.assignedBy = null;
      this.formTonUpdateData.assignedTo = null;

      this.notesFromAnyms = false;
      this.notesToAnyms = false;
    },

    cancelNewTon() {
      this.reset();
      this.hideThisModal(this.newCrewTonModal);
      this.resetObjCrewKeysPagination();
    },

    cancelTonRecord() {
      this.reset();
      this.hideThisModal(this.newCrewTonRecordModal);
      this.resetObjCrewKeysPagination();
    },

    cancelNewTonRecord() {
      this.reset();
      this.hideThisModal(this.newCrewTonRecordModal);
      this.resetObjCrewKeysPagination();
    },

    //region upload file methods
    uploadFile(objTon) {
      this.formTonUploadReplaceFile.crewTonId = objTon.crewTonId;
    },

    async saveUploadFile() {
      let msgHtml = '<span>Are you sure you want to save <br>the changes you made</span>';
      if (await this.questionFormAlert(msgHtml, 'Upload file')) {
        const formData = new FormData();
        formData.append('file', this.formTonUploadReplaceFile.file);
        formData.append('remarks', this.formTonUploadReplaceFile.remarks);
        formData.append('crewTonId', this.formTonUploadReplaceFile.crewTonId);
        this.uploadCrewTonFile(formData).then((r) => {
          if (r) {
            this.$nextTick(() => {
              this.successFormAlert('Upload successfully', 'Upload turnover notes');
              this.hideThisModal(this.uploadFileModal);
              this.resetFormTonUploadReplaceFile();
            });
          }
        });
      }
    },

    cancelUploadFile() {
      this.$nextTick(() => {
        this.hideThisModal(this.uploadFileModal);
        this.resetFormTonUploadReplaceFile();
        $(`#upload-attached-file`).val('');
      });
    },

    handleUploadFile(event) {
      this.formTonUploadReplaceFile.file = event.target.files[0];
    },
    //endregion

    //region replace file methods
    replaceFile(objTon) {
      this.formTonUploadReplaceFile.crewTonId = objTon.crewTonId;
    },

    async saveReplaceFile() {
      let msgHtml = '<span>Old file move into history <br> Do you want to replace existing file</span>';
      if (await this.questionFormAlert(msgHtml, 'Replace file')) {
        const formData = new FormData();
        formData.append('file', this.formTonUploadReplaceFile.file);
        formData.append('remarks', this.formTonUploadReplaceFile.remarks);
        formData.append('crewTonId', this.formTonUploadReplaceFile.crewTonId);
        this.replaceCrewTonFile(formData).then((r) => {
          if (r) {
            this.$nextTick(() => {
              this.successFormAlert('Turnover notes replace successfully.', 'Replaced turnover notes');
              this.hideThisModal(this.replaceFileModal);
              this.resetFormTonUploadReplaceFile();
            });
          }
        });
      }
    },

    cancelReplaceFile() {
      this.$nextTick(() => {
        this.hideThisModal(this.replaceFileModal);
        this.resetFormTonUploadReplaceFile();
        $(`#replace-attached-file`).val('');
      });
    },

    handleReplaceFile(event) {
      this.formTonUploadReplaceFile.file = event.target.files[0];
    },
    //endregion

    //cancel on main menu
    cancelTon() {
      // console.log('Test im cancelling this ton.');
    },

    async deleteTon(__crewTonId) {
      let msgHtml = '<span>Are you sure you want to delete this record.</span>';
      if (await this.questionFormAlert(msgHtml, 'Delete TON record', 'error')) {
        this.deleteCrewTon(__crewTonId).then((r) => {
          if (r) {
            this.successFormAlert('Delete successfully');
            this.$nextTick(() => {
              this.getVesselCrewTons(this.formTonPayload);
            });
          }
        });
      }
    },

    assignCrew(__type) {
      switch (__type) {
        case 1:
          this.assigned = 1;
          this.formTonPayload.assignedType = 1;
          if(this.formTonPayload.rankId !== this.formRankTmp){
            this.formTonPayload.rankId = this.formRankTmp
            this.searchCrewKeys()
          }
          break;

        case 2:
          this.assigned = 2;
          this.formTonPayload.assignedType = 2;
          this.searchCrewKeys()
          break;

        default:
          // this.assigned = null;
          break;
      }
    },

    remAssignedBy(val) {
      switch (val) {
        case 1:
          this.selectedAssignedBy = null;
          this.assigned = 1
          if(this.formTonPayload.rankId !== this.formRankTmp){
            this.formTonPayload.rankId = this.formRankTmp
            this.searchCrewKeys()
          }
          break;

        case 2:
          this.selectedAssignedTo = null;
          this.assigned = 2
          if(this.formTonPayload.rankId !== this.formRankTmp){
            this.formTonPayload.rankId = this.formRankTmp
            this.searchCrewKeys()
          }
          break;
      }
    },

    setPage(e) {
      this.formTonPayload.page = e;
      this.getCrewKeysPaginated(this.formTonPayload);
    },

    callSearchDebounce : __.debounce(function(){
      this.searchCrewKeys();
    },500),

    searchCrewKeys() {
      this.formTonPayload.page = 1;
      this.getCrewKeysPaginated(this.formTonPayload);
    },

    setCrew(__objCrew) {
      if (this.assigned != undefined && __objCrew !== undefined) {
        switch (this.assigned) {
          case 1:
            this.selectedAssignedBy = __objCrew.crew;
            break;

          case 2:
            this.selectedAssignedTo = __objCrew.crew;
            break;
        }
      }
    },

    /** handle file for new crew ton  **/
    handleFileNewCrewTon(event) {
      this.formNewCrewTon.file = event.target.files[0];
    },

    editTon(objTon) {
      this.setTonPayloadRank(objTon.rankId);
      this.formTonUpdateData.crewTonId = objTon.crewTonId;
      this.formTonPayload.rankId = objTon.rankId
      this.formTonPayload.isUpdate = 1
      this.formRankTmp = objTon.rankId
      this.defaultAssignedBy = objTon.assignedBy ? objTon.assignedBy.toUpperCase() : '';
      this.defaultAssignedTo = objTon.assignedTo ? objTon.assignedTo.toUpperCase() : '';
      this.$nextTick(() => {
        this.getCrewKeysPaginated(this.formTonPayload);
      });
    },

    async saveEditTon() {
      const formData = new FormData();
      let msgHtml = '<span>Are your sure to save changes that you made.</span>';
      if (await this.questionFormAlert(msgHtml, 'Edit TON details')) {
        formData.append('assignedBy',this.notesFromAnyms ? '' : this.formTonUpdateData.assignedBy);
        formData.append('assignedTo',this.notesToAnyms ? '' : this.formTonUpdateData.assignedTo);
        formData.append('crewTonId', this.formTonUpdateData.crewTonId);
        formData.append('remarks', this.formTonUpdateData.remarks);
        formData.append('file', this.formTonUpdateData.file);
        this.updateCrewTon(formData).then((r) => {
          if (r) {
            this.formTonUpdateData = {
              crewTonId: null,
              assignedBy: null,
              assignedTo: null,
              file: null,
            };
            this.formTonPayload.isUpdate = 0
            this.notesFromAnyms = false
            this.notesToAnyms = false
            this.reset();
            this.hideThisModal(this.editTonRecordModal);
            this.$nextTick(() => {
              //this.getVesselCrewTons(this.formTonPayload);
              this.successFormAlert('Update details successfully');
            });
          }
        });
      }
    },

    cancelEditTon() {
      this.hideThisModal(this.editTonRecordModal);
      this.formTonPayload.isUpdate = 0
      this.formTonPayload.assignedType = 1
      this.notesToAnyms = false;
      this.notesFromAnyms = false;
      this.$nextTick(() => {
        this.selectedAssignedBy = null;
        this.selectedAssignedTo = null;
        this.formTonUpdateData = {
          assignedBy: null,
          assignedTo: null,
        };
      });
    },

    handleFileUpdateCrewTOn(event) {
      this.formTonUpdateData.file = event.target.files[0];
    },

    //region remarks
    viewRemarks(obj) {
      //console.log('Test 123123',obj);
      this.formCrewTonId = obj?.crewTonId;
      this.setCrewTonRemarks(obj?.remarks);
      this.showThisModal(this.remarksModal);
    },

    setRemark(ton) {
      this.isViewingRemarks = true;
      this.setCrewTonRemark(ton);
    },

    async saveRemarks(obj = null) {
      let msgHtml = '<span>Are you sure you want to add this comment?</span>';
      if (this.isNewRemarks) {
        this.newCrewTonRemark.crewTonId = this.formCrewTonId;
        if (await this.questionFormAlert(msgHtml, 'Adding Comment')) {
          this.createTonRemark(this.newCrewTonRemark).then((r) => {
            if (r) {
              this.$nextTick(() => {
                this.successFormAlert('Adding remark successfully', 'Add remark');
                this.resetTextAreaRemark();
              });
            }
          });
        }
      }

      if (this.isEditable && !this.isNewRemarks) {
        let msgHtmlEmpty = '<span>Please provide remarks details. <br> Remarks should not be empty.</span>';
        let msgHtmlEdit = '<span>Do you want to save changes that you made.</span>';

        if (!__.isEmpty(this.crewTonRemark.remarks)) {
          if (await this.questionFormAlert(msgHtmlEdit, 'Editing remarks')) {
            this.updateTonRemark(this.crewTonRemark).then((r) => {
              if (r) {
                this.successFormAlert('Updating remark successfully', 'Update remark');
                this.resetTextAreaRemark();
              }
            });
          }
        } else {
          this.warningFormAlert(msgHtmlEmpty, 'Updating remark');
        }
      }
    },

    addRemarks() {
      this.isViewingRemarks = false;
      this.isNewRemarks = true;
      this.isEditable = true;
      if (!__.isEmpty(this.crewTonRemark)) {
        this.resetCrewTonRemark();
      }
    },

    editRemarks() {
      this.isEditable = true;
      this.isViewingRemarks = true;
      this.isNewRemarks = false;
    },


    resetTextAreaRemark() {
      this.isEditable = false;
      this.isNewRemarks = false;
      this.isAddComment = false;
      this.isViewingRemarks = false;
    },

    cancelTextAreaRemarks() {
      this.resetTextAreaRemark();
      if (!__.isEmpty(this.crewTonRemark)) {
        this.getCrewTonRemarkOriginal();
      }
    },

    cancelRemarks() {
      this.$nextTick(() => {
        this.resetCrewTonRemarksState();
        this.resetTextAreaRemark();
      });
    },

    async deleteRemarks() {
      let msgHtml = '<span>Do you want to delete this remarks</span>';
      if (await this.questionFormAlert(msgHtml, 'Delete remarks')) {
        this.deleteTonRemark(this.crewTonRemark).then((r) => {
          if (r) {
            this.$nextTick(() => {
              this.resetCrewTonRemark();
              this.resetTextAreaRemark();
              this.successFormAlert('Deleting remark record success', 'Delete remarks');
            });
          }
        });
      }
    },
    //endregion

    //region  history
    viewFileHistory(objTon = null) {
      // console.log('viewing ton', objTon);
      if (objTon != null) {
        this.setTonFileHistories(objTon);
      }
    },

    cancelFileHistory() {
      this.$nextTick(() => {
        this.resetFileHistoryVuex();
      });
    },

    async downloadThisFileHistory(obj) {
      let msgHtml = '<span>Are you sure you want to download this <br> TON history version</span>';
      if (await this.questionFormAlert(msgHtml, 'Download Turnover notes file history version')) {
        await this.downloadFileHistory(obj);
      }
    },


   async notesFromAnymsFn(e,isEdit = false){
      let msg = `<span>Click ok if turn over notes are <br> comes from crew not in the KRBS list</span>`;
      if(await this.questionFormAlert(msg,'Notes from other crew')){
        this.notesFromAnyms = true
        this.$el.querySelector(`#`+`${e}`).checked = true
        this.assigned = 2;

      }else {
        this.$el.querySelector(`#`+`${e}`).checked = false
        this.notesFromAnyms = false;
        this.assigned = 1;

        if(this.formTonPayload.rankId != this.formRankTmp){
          this.formTonPayload.rankId = this.formRankTmp
          this.searchCrewKeys()
        }
      }
    },


  async  notesToAnymsFn(e){
      let msg = `<span>Click ok if turn over notes <br>  crew receiver are not in the KRBS list</span>`;
      if(await this.questionFormAlert(msg,'Notes from other crew')){
        this.notesToAnyms = true
        this.$el.querySelector(`#`+`${e}`).checked = true
        this.assigned = 1;

        if(this.formTonPayload.rankId != this.formRankTmp){
          this.formTonPayload.rankId = this.formRankTmp
          this.searchCrewKeys()
        }

      }else {
        this.$el.querySelector(`#`+`${e}`).checked = false
        this.notesToAnyms = false;
        this.assigned = 2;

      }
    }



    //endregion
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'authUser',
          // 'authPos',
          'isLoading',
          'isSearchingCrew',
          'crewTon',
          'formTonPayload',
          'formNewCrewTon',
          'formTonUploadReplaceFile',

          //obj
          'objCrewKeys',
          'objCrewKeysPagination',
          'objRankKeys',

          'crewTonRemark',
          'crewTonRemarks',
          'newCrewTonRemark',

          //crewTon file histories
          'crewTonFileHistories',
        ],
    ),

    thisAssigned() {
      return this.assigned == 1 ? 'Search Notes From' : 'Search Notes To';
    },

    thisAssignedBy: {
      get() {
        if (this.selectedAssignedBy != undefined) {
          return `${this.selectedAssignedBy.lastName}, ${this.selectedAssignedBy.firstName} ${this.selectedAssignedBy.middleName}`;
        }
        return null;
      },
    },

    thisAssignedTo: {
      get() {
        if (this.selectedAssignedTo != undefined) {
          return `${this.selectedAssignedTo.lastName}, ${this.selectedAssignedTo.firstName} ${this.selectedAssignedTo.middleName}`;
        }
        return null;
      },
    },
  },

  /** mounted **/
  mounted() {
    // console.log(AppService.originalState('auth', 'authUser').manningId);
  },

  /** created **/
  created() {
    this.loadData();
  },

  watch: {
    /*  crewTon: {
        handler: 'loadData',
        immediate: true,
        deep: true,
      },*/

    isEditable: {
      handler: function(val) {
        if (val) {
          this.isAddComment = true;
        } else {
          this.isAddComment = false;
        }
      },
      immediate: true,
      deep: true,
    },

    isNewRemarks: {
      handler: function(val) {
        if (val) {
          this.isAddComment = true;
        } else {
          this.isAddComment = false;
        }
      },
      immediate: true,
      deep: true,
    },

    selectedAssignedBy: {
      handler: function(val) {
        if (val !== null) {
          this.formNewCrewTon.assignedBy = val.id;
          this.formTonUpdateData.assignedBy = val.id;
          this.selectedActive = val.id;
        } else {
          this.formNewCrewTon.assignedBy = null;
          this.formTonUpdateData.assignedBy = null;
        }
      },
      immediate: true,
      deep: true,
    },

    selectedAssignedTo: {
      handler: function(val) {
        if (val !== null) {
          if (val.id == this.formNewCrewTon.assignedBy || val.id == this.formTonUpdateData.assignedTo) {
            this.warningFormAlert('Notes From and Notes to should not be the same.');

          } else {

            this.formNewCrewTon.assignedTo = val.id;
            this.formTonUpdateData.assignedTo = val.id;
            this.selectedActive = val.id;
          }
        } else {
          this.formNewCrewTon.assignedTo = null;
          this.formTonUpdateData.assignedTo = null;
        }
      },
      immediate: true,
      deep: true,
    },
  },

  /** destroyed **/
  destroyed() {
    this.resetCrewTon();
    this.resetCrewTonRemarksState();
    this.formRankTmp = null;
    this.formTonPayload.isUpdate = 0;
  },
};
</script>

<style scoped>


.img-icon {
  width: 20px !important;
  height: 20px !important;
}

.plain-btn {
  border: 0;
  padding: .15em .45em;
  color: #2c3e50;
  border-radius: 100%;
  margin: 0 .15em;
  outline-style: none;
  background-color: white;
}

.is-selected {
  background-color: #AFCBE7 !important;
}

.unclickable {
  pointer-events: none !important;
}


.plain-btn {
  border: 0 !important;
  padding: .15em .45em !important;
  color: #2c3e50 !important;
  font-size: .75em !important;
  border-radius: 100% !important;
  margin: 0 .15em !important;
  outline-style: none !important;
  background-color: white !important;
}

.plain-btn-active {
  border: 0 !important;
  padding: .15em .45em !important;
  font-size: .75em !important;
  color: white !important;
  border-radius: 100% !important;
  margin: 0 .15em !important;
  outline-style: none !important;
  background-color: #007BFF !important;
}

.plain-btn:hover {
  background-color: rgba(0, 0, 0, .1) !important;
}

.plain-btn:focus {
  background-color: rgba(0, 0, 0, .1) !important;
}

.plain-btn:active {
  background-color: rgba(0, 0, 0, .1) !important;
}

.unclickable-table-row {
  cursor: none !important;
}

.btn-sm {
  padding: 3px 6px !important;
  font-size: .75em !important;
  border-radius: 2px !important;
}

#up-notes-frm-checkbox {
  transform: scale(1.5);
}


</style>
